import { useEffect } from "react";
import { toast } from "react-toastify";
import AccountingLandingHeader from "../components/accounting/AccountingLandingHeader";
import AccountingSummaryCard from "../components/accounting/AccountingSummaryCard";
import {
  useGetCounterOpeningBalance,
  useGetCounterSummary,
  usePostCounterOpen,
} from "../service/counterService";
import { useNavigate } from "react-router-dom";

export default function AccountingLanding() {
  const navigate = useNavigate();
  const counterId = localStorage.getItem("counterId") ?? undefined;
  const branchId = localStorage.getItem("branchId") ?? undefined;

  // If a session is already open, go straight to the listing page
  const { data: counterSummary, isSuccess: summaryLoaded } =
    useGetCounterSummary({ branchId, counterId });

  useEffect(() => {
    if (summaryLoaded && counterSummary?.status === "OPEN") {
      navigate("/accounting-list");
    }
  }, [summaryLoaded, counterSummary, navigate]);

  const { data: openingBalanceData } = useGetCounterOpeningBalance({
    counterId,
    branchId,
  });

  const openMutation = usePostCounterOpen();

  const handleConfirm = () => {
    openMutation.mutate(
      {
        counterId: Number(counterId),
        openingCash: openingBalanceData?.openingCash ?? 0,
        openingBank: openingBalanceData?.openingBank ?? 0,
        branchId,
      },
      {
        onSuccess: () => {
          toast.success("Accounting balance confirmed successfully.");
          navigate("/accounting-list");
        },
        onError: (error: Error) => {
          toast.error(`Failed to confirm accounting balance: ${error.message}`);
        },
      },
    );
  };

  return (
    <div className="min-h-[calc(100vh-120px)] flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-[600px]">
        <AccountingLandingHeader
          selectedDate={openingBalanceData?.date || ""}
        />
        <AccountingSummaryCard
          cash={openingBalanceData?.openingCash ?? 0}
          bank={openingBalanceData?.openingBank ?? 0}
          openingBalance={openingBalanceData?.openingBalance ?? 0}
          onConfirm={handleConfirm}
        />
      </div>
    </div>
  );
}
